// extracted by mini-css-extract-plugin
export default {"placeholder":"NFTAssets_placeholder__F0PE6"};